export enum mainModules {
  administration = "administration",
  configuration = "configuration",
  productionPlanning = "productionPlanning",
  myPlaneus = "myPlaneus",
}

// Production Planning
export enum productionPlanningModules {
  articlepartslist = "articlepartslist",
  automatedimport = "automatedimport",
  basedata = "basedata",
  basedatareadonly = "basedatareadonly",
  conflictRadar = "conflictRadar",
  conflictRadarreadonly = "conflictRadarreadonly",
  dashboard = "dashboard",
  gaplist = "gaplist",
  import = "import",
  planningObjects = "planningObjects",
  planningObjectsreadonly = "planningObjectsreadonly",
  planning = "planning",
  planningreadonly = "planningreadonly",
  productionPlanning = "productionPlanning",
  reports = "reports",
  rfidlogin = "rfidlogin",
  splitorderposition = "splitorderposition",
  simulation = "simulation",
  terminal = "terminal",
  workbench = "workbench",
  workbenchphotos = "workbenchphotos",
  workbenchscan = "workbenchscan",
}

export enum planningObjectsTabs {
  activities = "activities",
  orders = "orders",
  operations = "operations",
  productionOrders = "productionOrders",
  projects = "projects",
  orderPositions = "orderPositions",
}

export enum planningTabs {
  production = "production",
  timeline = "timeline",
}

export enum workbenchTabs {
  workbenchactivities = "workbenchactivities",
  workbenchoperations = "workbenchoperations",
}

export enum conflictRadarTabs {
  affectedoperations = "affectedoperations",
  conflicts = "conflicts",
  delayed = "delayed",
  import = "import",
}

export enum basedataTabs {
  articles = "articles",
  customers = "customers",
  material = "material",
  qualifications = "qualifications",
  resources = "resources",
  resourcepriority = "resourcepriority",
  templates = "templates",
  technologies = "technologies",
  technologyItems = "technologyItems",
}

export enum reportingTabs {
  reportingplugins = "reportingplugins",
}

export enum importTabs {
  automatedimport = "automatedimport",
}

export enum characteristicsTabs {
  characteristicsPhysical = "characteristicsPhysical",
  characteristicsFree = "characteristicsFree",
  characteristicsOrder = "characteristicsOrder",
}

export enum organizationTabs {
  departments = "departments",
  locations = "locations",
}

// Administration
export enum administrationModules {
  backup = "backup",
  globalsettings = "globalsettings",
  licences = "licences",
  userManagement = "userManagement",
  planeusTv = "planeusscreen",
  workbenchterminal = "workbenchterminal",
  security = "security",
}

export enum userManagementTabs {
  roles = "roles",
  userroles = "userroles",
  dashboardroles = "dashboardroles",
  users = "users",
}

export enum LicenceTabs {
  licenceOverview = "licenceOverview",
  licenceManagement = "licenceManagement",
}

// Configuration
export enum configurationModules {
  articleGroups = "articleGroups",
  availabilityplans = "availabilityplans",
  characteristics = "characteristics",
  customFields = "customfields",
  equipments = "equipments",
  calendar = "calendar",
  gaptypes = "gaptypes",
  locations = "locations",
  objectNames = "objectNames",
  pools = "pools",
  resourceGroups = "resourceGroups",
  resourcePrograms = "resourcePrograms",
  rejecttypes = "rejecttypes",
  storageLocations = "storageLocations",
  troubletypes = "troubletypes",
  units = "units",
}

// My Planeus
export enum myPlaneusModules {
  languages = "languages",
  modulepreferences = "modulepreferences",
  userinfo = "userinfo",
}

// Administration/GlobalSettings
export enum globalSettingTabs {
  planningObjects = "planningObjectsSettings",
  planning = "planningSettings",
  workbench = "workbenchSettings",
  import = "importSettings",
  reporting = "reportingSettings",
  security = "securitySettings",
}

export const mainModuleMapping: Record<string, mainModules> = {
  ...Object.fromEntries(Object.values(productionPlanningModules).map(m => [m, mainModules.productionPlanning])),
  ...Object.fromEntries(Object.values(administrationModules).map(m => [m, mainModules.administration])),
  ...Object.fromEntries(Object.values(configurationModules).map(m => [m, mainModules.configuration])),
  ...Object.fromEntries(Object.values(myPlaneusModules).map(m => [m, mainModules.myPlaneus])),
}
